import { YupSchema } from 'services/yup/types'
import {
  yupArray,
  yupIgnore,
  yupNumber,
  yupObject,
  yupString,
} from 'services/yup'
import { packageBaseVS } from './packageBase'
import {
  DeliveryTimeLogic,
  FoodPackage,
  FoodPreset,
} from 'services/api/entities/catalog/packages/foodPackage'
import { optionedPresetVS } from './optionedPackage'

const foodPresetVS: YupSchema<FoodPreset> = optionedPresetVS.shape({
  logistic: yupNumber().required(),
  deliveryTimeLogic: yupString<DeliveryTimeLogic>(),
  logisticFull: yupObject(),
})

export const foodPackageVS: YupSchema<FoodPackage> = packageBaseVS.shape({
  products: yupArray(foodPresetVS).min(1),
  isBundledPackage: yupIgnore(),
})
